import React from 'react';
import { HeaderMenuItem } from '../headerMenuItem/HeaderMenuItem';
import { getParticularItems, getPublisherItems, getSeekerItems, mockUserType } from '../../../../../mockData';

function HeaderMenuItemList(props) {
  const { onMenuItemClick, user } = props;
  // eslint-disable-next-line no-nested-ternary
  const userType = user.isSeeker ? 'seeker' : user.publisherTypeId === '1' ? 'particular' : 'publisher';
  const isAdminOrSuperuser = ['1', '2'].includes(user.userTypeId);

  let publisherTypeData = [];
  let items = [];
  if (user.publisherTypeId === '1' && !user.isSeeker) {
    items = getParticularItems('dropdown');
  } else if (user.publisherTypeId !== '1' && user.isSeeker) {
    items = getSeekerItems('dropdown');
  } else {
    items = getPublisherItems(user.userTypeId === '1' ? 'mobileAdmin' : 'mobile');
    publisherTypeData = mockUserType.filter(index => index.id === user.publisherTypeId);
  }

  /**
   * La función evalua si el usuario tiene o no permisos para ver la pestaña
   * @param item - Recibe un item que representa una pestaña
   * @returns {boolean} - Retorna true si el usuario puede ver la pestaña enviada por param
   */
  const getIsAuthorizedTabByUserType = item => {
    if (!isAdminOrSuperuser && item.icon === 'stats') return false;
    return true;
  };

  return (
    <div data-panel='headerMenuItemList'>
      {items &&
        user.email &&
        items.map(
          item =>
            ((item.icon === 'assessments' && user.showTasador) || item.icon !== 'assessments') &&
            getIsAuthorizedTabByUserType(item) && (
              <HeaderMenuItem
                key={item.icon}
                item={item}
                user={user}
                onMenuItemClick={onMenuItemClick}
                border={item.border && item.border.includes(userType) ? 1 : 0}
                publisherData={
                  item.icon === 'realEstate' && publisherTypeData.length ? publisherTypeData[0].title : null
                }
              />
            )
          // )
        )}
    </div>
  );
}

export { HeaderMenuItemList };
